import type { Locale } from "@/lib/i18n";
import { pl, type WShopPromotionalProductsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wShopPromotionalProductsTranslations: Record<
  Locale,
  WShopPromotionalProductsTranslations
> = {
  pl,
  en,
  de,
};

export type { WShopPromotionalProductsTranslations };
